import { IResponse } from "../../model";
import ServiceBase from "../../servicebase";
import { ICountry } from "./model";

export default class CountryService extends ServiceBase {
  all = () : Promise<IResponse<ICountry[]>> => 
    this.GetFetch<IResponse<ICountry[]>>('country/all', {});
}
